export default "__VITE_ASSET__CK2P$Pix__"